import { render } from "./leaves-admin-model2.vue?vue&type=template&id=3042bab4"
import script from "./leaves-admin-model2.vue?vue&type=script&lang=js"
export * from "./leaves-admin-model2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__